var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classAttr,style:(_vm.extraStyle),attrs:{"icon":"","small":"","color":"white"},on:{"click":function($event){return _vm.$emit('change')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(this.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }